

// REPO PATH:  src/front-end/code/slices/editLock.js
//
// true while a screen is in list-edit mode (Controls, Automations).
// The menubar disables navigation while set, so the user can't walk
// away from an open editor or unsaved changes mid stream — they must
// Done / Save / Cancel first. Screens publish their local listEditMode
// here (and clear it on unmount) because the menubar can't see
// component-local state.

import { createSlice } from '@reduxjs/toolkit';

const editLockSlice = createSlice({
	name: 'editLock',
	initialState: false,
	reducers: {
		setEditLock: (state, action) => !!action.payload,
	},
});

export const { setEditLock } = editLockSlice.actions;
export default editLockSlice.reducer;